import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-recon-files',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-workday-payment.component.html',
  styleUrl: './view-workday-payment.component.css'
})
export class ViewWorkdayPaymentComponent {

}
